import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import styles from './ErrorState.module.css';

interface ErrorStateProps {
  error: string;
  onRetry?: () => void;
}

export function ErrorState({ error, onRetry }: ErrorStateProps) {
  return (
    <div className={styles.container} role="alert">
      <div className={styles.iconWrapper}>
        <AlertCircle className={styles.icon} />
      </div>
      
      <h3 className={styles.title}>Unable to Load Game</h3>
      
      <p className={styles.message}>
        {error || 'Something went wrong while loading the game details.'}
      </p>
      
      {onRetry && (
        <button onClick={onRetry} className={styles.retryButton}>
          <RefreshCw className={styles.retryIcon} />
          <span>Try Again</span>
        </button>
      )}
    </div>
  );
}